module.exports = __webpack_public_path__ + "static/media/Adviesbox_HDN.642bf25d.png";